// extracted by mini-css-extract-plugin
export var contacts = "ModalAside-module--contacts--5f53f";
export var detailIcon = "ModalAside-module--detailIcon--368d5";
export var detailItem = "ModalAside-module--detailItem--37b7a";
export var details = "ModalAside-module--details--f171e";
export var fadeInAnimation = "ModalAside-module--fadeInAnimation--fb586";
export var owner = "ModalAside-module--owner--722a9";
export var section = "ModalAside-module--section--d9891";
export var sectionTitle = "ModalAside-module--sectionTitle--63fd0";
export var wrapper = "ModalAside-module--wrapper--3eafb";